import apiClient from "../apiClient";

export const LeaveAPI = {
  getAllMyEmployeeLeaveCredits: () =>
    apiClient.get("/api/v1/requests/leave/leave-credits"),
  getAllLeaveRequestsPaginated: ({ page, pageSize, filters }) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters || {}).filter(([_, value]) => value !== null)
    );

    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...cleanFilters,
    });
    return apiClient.get(`/api/v1/requests/leave?${params.toString()}`);
  },
  createLeaveRequest: ({
    leaveTypeID,
    startDate,
    endDate,
    durationDays,
    requestType,
    mediaID,
    reason,
  }) =>
    apiClient.post("/api/v1/requests/leave", {
      LeaveTypeID: leaveTypeID,
      StartDate: startDate,
      EndDate: endDate,
      DurationDays: durationDays,
      RequestType: requestType,
      MediaID: mediaID,
      Reason: reason,
    }),
};
